module.exports = __webpack_public_path__ + "0adbf54d28669569ac49f1ad9e6c19b7.pdf";